import { OFFLINE } from '../actions/index';

export default (state = false, action) => {
      switch(action.type){
            case OFFLINE :
                return action.payload;
            default :
                return false;
        }
}